module.exports = __webpack_public_path__ + "img/tableMenu.e8c784a0.png";